import { REFINANCING_LIMITS } from "shared/CalculatorLimits";

export const getMaxPaidYears = (years: number) =>
	Math.max(REFINANCING_LIMITS.paidPeriodMin, years - 1);
